import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-device",
  "use": "svg-icon-device-usage",
  "viewBox": "0 0 32 16",
  "content": "<symbol viewBox=\"0 0 32 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-device\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.878 2h6.251v10h-6.25V2zm7.814 0v14h-9.377V0h9.377v2zm-5.47 12c0 .553.35 1 .782 1 .432 0 .78-.447.78-1 0-.553-.348-1-.78-1-.433 0-.782.447-.782 1zM2.246 1a1 1 0 0 1 1-1h11.479a1 1 0 0 1 1 1v10.938a1 1 0 0 1-1 1h3.246v.874a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-.874h3.246a1 1 0 0 1-1-1V1zM3.37 2.875h11.232v7.188H3.37V2.875z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol